import { render, staticRenderFns } from "./_WizardOverview.vue?vue&type=template&id=2ee7da52&"
import script from "./_WizardOverview.vue?vue&type=script&lang=ts&"
export * from "./_WizardOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports